module.exports = __webpack_public_path__ + "img/glitter_14.265416d1.jpg";